import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';
import ScrollAnimation from 'src/components/ScrollAnimation';

const Timeline = ({ data }) => (
  <Root>
    {data.map((item, index) => (
      <ScrollAnimation key={index}>
        <Content last={index === data.length - 1}>
          <h3>{item.date}</h3>
          <DesktopContent>
            <ImageContainer>
              <img src={item.image} alt={item.title} />
            </ImageContainer>
            <div>
              <Credit>{item.credit}</Credit>
              <h2>{item.title}</h2>
              <Text>{item.description}</Text>
            </div>
          </DesktopContent>
        </Content>
      </ScrollAnimation>
    ))}
  </Root>
);

export default Timeline;

Timeline.propTypes = {
  data: PropTypes.array,
};

const Root = styled.div``;

const Content = styled.div`
  width: 90%;
  margin: 0 auto;
  margin-bottom: ${props => (props.last ? '50px' : '160px')};
  position: relative;
  @media (min-width: ${media.smup}) {
    margin-bottom: ${props => (props.last ? '150px' : '70px')};
  }
  &::after {
    content: '';
    width: 4px;
    height: 150px;
    background: linear-gradient(to bottom, #ff7802, rgba(255, 255, 255, 0));
    display: ${props => (props.last ? 'none' : 'block')};
    position: absolute;
    top: 102%;
    left: 50%;
    @media (min-width: ${media.smup}) {
      top: 12%;
      height: 110%;
      display: block;
    }
  }
  h2 {
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 22px;
    color: ${({ theme }) => theme.colorPrimary};
    letter-spacing: 0;
    text-align: left;
    text-transform: uppercase;
    line-height: 32px;
    font-weight: 500;
    @media (min-width: ${media.smup}) {
      text-align: right;
    }
  }
  h3 {
    text-align: center;
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 20px;
    color: ${({ theme }) => theme.colorDarkBlue};
    line-height: 32px;
    font-weight: 500;
    @media (min-width: ${media.smup}) {
      margin-bottom: 10px;
    }
  }
  img {
    max-width: 100%;
    min-height: 240px;
    object-fit: cover;
    margin: 20px auto;
    display: block;
    @media (min-width: ${media.smup}) {
      margin: 0;
    }
  }
`;

const Text = styled.p`
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  color: rgba(0, 0, 0, 0.72);
  letter-spacing: 0;
  line-height: 24px;
  margin: 20px 0;
  @media (min-width: ${media.smup}) {
    text-align: right;
  }
`;

const Credit = styled.p`
  color: ${({ theme }) => theme.colorPrimary};
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 12px;
  line-height: 15px;
  @media (min-width: ${media.smup}) {
    text-align: right;
  }
`;

const DesktopContent = styled.div`
  @media (min-width: ${media.smup}) {
    display: flex;
    margin: 0 auto;
    @media (min-width: ${media.mdup}) {
      max-width: 930px;
    }
    div:nth-of-type(2) {
      order: 1;
      width: 50%;
      padding-right: 50px;
    }
  }
`;

const ImageContainer = styled.div`
  @media (min-width: ${media.smup}) {
    width: 50%;
    order: 2;
    padding-left: 54px;
    display: flex;
    justify-content: center;
    max-height: 330px;
    img {
      object-fit: cover;
      max-height: 240px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Timeline.js